var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1200,
    width: 1600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#effaff",
    width: 1600,
    height: 1200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M591.94 1126.85H675.76",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.31 1126.85H721.72",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.83 1126.85H1041.11",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.74 1010.52H637.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.96 1010.52H792.02",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.02 1010.52H819.2C831.44 1010.52 841.47 1000.56 841.47 988.25 841.47 976.01 831.51 965.98 819.2 965.98H802.76",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.85 1126.85H1069.29C1076.69 1126.85 1082.74 1120.8 1082.74 1113.4 1082.74 1106 1076.69 1099.95 1069.29 1099.95H1059.33",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.14 1153.67H1141.58C1148.98 1153.67 1155.03 1147.63 1155.03 1140.23 1155.03 1132.83 1148.98 1126.78 1141.58 1126.78H1091.56",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.67 1038.55H901.16",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.44 1038.55H944.35",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1301.69 380.62C1272.34 332.31 1231.73 291.73 1182.53 265.76 1105.64 225.38 1015.09 224.14 929.25 233.49 868.23 240.18 797.9 258.89 782.11 329.63 659.81 327.72 537.05 315.12 414.93 325.43 357.33 330.21 300.29 349.59 269.64 403.44 195.8 532.52 312.29 664.65 398.41 748.48 548.49 894.36 764.76 895.79 958.78 885.67 1095.39 878.61 1249.91 840.71 1319.97 706.95 1373.69 604.79 1360.4 477.24 1301.69 380.62Z",
    fill: "#deeff7",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M988.82 636.28H611.18V965.8H988.82V636.28Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.9 763.52C839.9 741.52 822 723.63 800 723.63 778 723.63 760.1 741.52 760.1 763.52 760.1 778.63 768.31 791.27 780.46 798.17L763.39 878.46H836.78L819.7 798.17C831.85 791.27 839.9 778.3 839.9 763.52Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 312.17C731.04 312.17 675.22 368 675.22 436.96V635.95H925.27V436.96C924.78 368.33 868.96 312.17 800 312.17Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M481.86 520.3C517.97 520.3 547.25 491.03 547.25 454.92 547.25 418.81 517.97 389.54 481.86 389.54 445.75 389.54 416.48 418.81 416.48 454.92 416.48 491.03 445.75 520.3 481.86 520.3Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.86 467.45C493.24 467.45 502.46 458.23 502.46 446.86 502.46 435.48 493.24 426.26 481.86 426.26 470.49 426.26 461.27 435.48 461.27 446.86 461.27 458.23 470.49 467.45 481.86 467.45Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.66 464.85H472.06V483.77H491.66V464.85Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.06 471.11H486.52",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.06 477.5H491.66",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.65 464.85H477.95L474.6 444.87H489L485.65 464.85Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M340.99 965.83V876.31",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.99 899.18C324.18 899.18 310.56 885.56 310.56 868.75 310.56 851.94 324.18 838.31 340.99 838.31 357.8 838.31 371.42 851.94 371.42 868.75 371.42 885.56 357.8 899.18 340.99 899.18Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.35 725.16V698.3C456.35 675.6 437.99 657.24 415.29 657.24 392.59 657.24 374.23 675.6 374.23 698.3V791.22C374.23 813.92 392.59 832.28 415.29 832.28 437.99 832.28 456.35 813.92 456.35 791.22V739.19 725.16 725.16Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46 733.75L415.21 754.49 436.03 733.75",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46 756.96L415.21 777.7 436.03 756.96",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21 965.83V733.75",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2 894.17V727.88",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2 965.83V915.76",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.79 965.83H210.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1290 965.91V858.12",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 885.66C1310.24 885.66 1326.65 869.25 1326.65 849.01 1326.65 828.77 1310.24 812.37 1290 812.37 1269.77 812.37 1253.36 828.77 1253.36 849.01 1253.36 869.25 1269.77 885.66 1290 885.66Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.09 676.12V643.77C1151.09 616.44 1173.21 594.33 1200.54 594.33 1227.87 594.33 1249.98 616.44 1249.98 643.77V755.66C1249.98 782.99 1227.87 805.1 1200.54 805.1 1173.21 805.1 1151.09 782.99 1151.09 755.66V693.01 676.12 676.12Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.62 686.46L1200.64 711.43 1175.56 686.46",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.62 714.4L1200.64 739.38 1175.56 714.4",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.64 965.91V686.46",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.86 879.62V679.39",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.86 965.91V905.62",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.45 965.91H1447.13",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1328.43 212.74L1464.06 212.74C1475 212.74 1484.01 221.68 1484.01 232.69 1484.01 243.64 1475.07 252.64 1464.06 252.64L1328.43 252.64C1317.49 252.64 1308.48 243.71 1308.48 232.69 1308.48 221.6 1317.34 212.74 1328.43 212.74Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.76 274.53H1361.63",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.15 274.53H1266.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.26 274.53C1382.4 274.53 1392.15 264.7 1392.15 252.64",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1216.86 350.62H1233.7C1243.11 350.62 1250.8 342.93 1250.8 333.52",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 368.26C1191.93 358.51 1199.76 350.69 1209.5 350.69",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.71 308.26H1064.71C1055.36 308.26 1047.8 300.7 1047.8 291.35 1047.8 282.01 1055.36 274.45 1064.71 274.45H1087.58",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.64 274.58H1235.22C1247.75 274.58 1258.03 264.44 1258.03 251.77 1258.03 239.24 1247.89 229.04 1235.22 229.04H1221.3",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.39 274.58H1178.28",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.31 229.1C1277.85 229.1 1285.48 221.34 1285.48 211.86V186.61",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.29 229.1H1261.41",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.c3829a55a38ead78baacb63f78494525.svg";
export { ForwardRef as ReactComponent };